import { JUMP_INFO, needEncodeURIComponent } from "./constants";
import avatrNative from "@avatr/jsbridge";
import openApp from "./openApp";
import { navigateToWeappCR } from "./weappNavigation";
import { BROWSER_TYPE, AUTH_TOKEN, AUTH_TOKEN_REFRESH } from "libs/conf";
import { Toast } from "antd-mobile";
import { uploadIssueFiles, IssueInfo } from "services/app";
import { clientHelper } from "avatr-utils";

// 发帖方法
export const publicPost = async (data: IssueInfo) => {
  // 发帖api: http://wiki.avatr.com/pages/viewpage.action?pageId=15139855
  // 参数不全，如需新增参数请参考文档
  if (BROWSER_TYPE.App) {
    const { contentType, title, content, commonLinks, imageUrl } = data;
    const appParams: any = {
      postType: contentType,
    };
    if (title) appParams.title = title;
    if (content) appParams.content = content;
    if (commonLinks && commonLinks.length > 0) {
      appParams.topicList = commonLinks.map((item) => {
        const { bizId, content } = item;
        return { topicId: bizId, topicName: content };
      });
    }
    if (imageUrl && imageUrl.length > 0) {
      appParams.urlList = imageUrl;
    }
    avatrNative.callNative("publishPage", appParams);
  } else if (BROWSER_TYPE.Weapp) {
    const { contentType } = data;
    const { code, result } = await uploadIssueFiles(data);
    if (code === 0) {
      // @ts-ignore
      const { temporaryStorageId } = result;
      wx.miniProgram.navigateTo({
        url: `/packages/community/pages/issue/index?origin=${contentType}&evaluationId=${temporaryStorageId}`,
      });
    }
  } else {
    showToast({
      type: "error",
      message: "请在阿维塔App或者小程序中打开该发帖页面",
    });
  }
};

// 用于资源位方法跳转
const ResourceFn = {
  publicPost,
  switchToCarTab,
  wxCustomer,
};

// 资源位跳转
export const ResourceNavigation = (item: {
  jumpType: string | number;
  jumpRoute: string;
  wxFailMessage?: string;
}) => {
  const { jumpType, jumpRoute, wxFailMessage } = item;
  if (!JUMP_INFO[jumpType]) {
    Toast.show(`不支持当前资源位跳转[${jumpType}]`);
    return;
  }
  const {
    wxUrl,
    appScheme,
    encodeURIComponentUrl,
    appNeedEncode = true,
    fnName,
    fnParams,
  } = JUMP_INFO[jumpType];

  if (fnName) {
    ResourceFn[fnName](fnParams);
    return;
  }

  if (BROWSER_TYPE.App) {
    let path = appScheme;
    if (encodeURIComponentUrl === needEncodeURIComponent && appNeedEncode) {
      path += encodeURIComponent(jumpRoute);
    } else if (encodeURIComponentUrl && appNeedEncode) {
      path += encodeURIComponent(`${encodeURIComponentUrl}${jumpRoute}`);
    } else {
      path += jumpRoute;
    }
    console.log(path, "path===");
    openApp(path);
  } else if (BROWSER_TYPE.Weapp) {
    // MiniResourceNavigation(item)

    if (!wxUrl) {
      showToast({
        type: "normal",
        message: wxFailMessage || `小程序不支持该跳转${[jumpType]}`,
      });
      return;
    }
    let path = wxUrl;
    const wxType = getWxJumpKey(path);
    if (!encodeURIComponentUrl) {
      path += jumpRoute;
    } else {
      path += encodeURIComponent(
        `${
          encodeURIComponentUrl === needEncodeURIComponent
            ? ""
            : encodeURIComponentUrl
        }${jumpRoute}`
      );
    }
    path = path.replace(/\s*/g, "");
    wx.miniProgram[wxType]({ url: path });
  } else {
    showToast({
      type: "normal",
      message: "请在阿维塔App或者小程序中打开该页面",
    });
  }
};

function getWxJumpKey(route: string) {
  const tabList = [
    "/pages/home/index",
    "/pages/account/index",
    "/pages/car/index",
    "/pages/shop/home/index",
  ];
  let jumpKey = "navigateTo";
  tabList.forEach((item) => {
    if (route.includes(item)) jumpKey = "switchTab";
  });
  return jumpKey;
}

// 提示
export const showToast = (data: {
  type: "normal" | "error" | "success";
  message: string;
}) => {
  // type: error/success/normal
  if (BROWSER_TYPE.App) {
    avatrNative.callNative("showToast", data);
  } else {
    const { message = "" } = data;
    Toast.show({
      content: message,
    });
  }
};

// 分享微信好友
export function shareWeChat(filePath: string) {
  if (!filePath) {
    showToast({ type: "error", message: "请选择图片" });
    return;
  }
  if (BROWSER_TYPE.App) {
    avatrNative.callNative("shareFileToWechat", { filePath });
  } else {
    showToast({ type: "error", message: "请在阿维塔App中执行该操作" });
  }
}

// 分享微信朋友圈
export function shareWeChatMoments(filePath: string) {
  if (!filePath) {
    showToast({ type: "error", message: "请选择图片" });
    return;
  }
  if (BROWSER_TYPE.App) {
    avatrNative.callNative("shareFileToWechatMoments", { filePath });
  } else {
    showToast({ type: "error", message: "请在阿维塔App中执行该操作" });
  }
}

// 保存图片
export function saveImage(filePath: string) {
  if (!filePath) {
    showToast({ type: "error", message: "请选择图片" });
    return;
  }
  if (BROWSER_TYPE.App) {
    avatrNative.callNative("saveImage", { filePath });
  } else {
    showToast({ type: "normal", message: "长按保存图片" });
  }
}

// 私信好友
export function shareFriends(imgUrl: string) {
  if (!imgUrl) {
    showToast({ type: "error", message: "请选择图片" });
    return;
  }
  if (BROWSER_TYPE.App) {
    avatrNative.callNative("shareFriends", { imgUrl });
  } else {
    showToast({ type: "error", message: "请在阿维塔App中执行该操作" });
  }
}

// 客服
export function wxCustomer() {
  if (BROWSER_TYPE.App) {
    window.location.href = `avatar://wxCustomer`;
  } else if (BROWSER_TYPE.Weapp) {
    navigateToWeappCR();
  }
}

// 切换至爱车tab
export function switchToCarTab() {
  if (BROWSER_TYPE.App) {
    avatrNative.callNative("jumpCarHome");
  } else if (BROWSER_TYPE.Weapp) {
    wx.miniProgram.switchTab({ url: "/pages/car/index" });
  } else {
    showToast({ type: "error", message: "请在阿维塔App或小程序中执行该操作" });
  }
}

/**
 * 刷新token
 */
export async function refreshToken(): Promise<string> {
  if (!BROWSER_TYPE.App) return "";
  try {
    const res = await avatrNative.asyncCallNative<{
      token: string;
    }>("refreshToken");
    const token = res?.token;
    if (token) {
      window.localStorage.setItem(AUTH_TOKEN, token);
      window.localStorage.setItem(AUTH_TOKEN_REFRESH, token);

      return token;
    }
    return "";
  } catch {
    return "";
  }
}

// 判断JSbridge中方法是否可用，返回boolean
export async function canIUseIt(fnName: string) {
  if (!fnName) return false;
  const { result } = await avatrNative.canIUse([fnName]);
  return result || false;
}

// 将base64转换为blob
export function dataURLtoFile({ base64Data, fileName, type = "jpg" }): File {
  const arr = base64Data.split(",");
  const bstr = window.atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  const file = new File([u8arr], `${fileName}.${type}`, {
    type: `image/${type}`,
  });
  return file;
}

//图片地址转base64格式
export function imgToBase64(url, cb) {
  var canvas = document.createElement("canvas"),
    ctx = canvas.getContext("2d"),
    img = new Image();
  img.crossOrigin = "Anonymous";
  img.onload = function () {
    canvas.height = img.height;
    canvas.width = img.width;
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL("image/png");
    cb && cb(dataURL);
    canvas = null;
  };
  img.src = url;
}

export type HeaderRightOperationItem = {
  key?: string;
  type: string;
  icon: string;
  url: string;
};

// 设置app右上角的icon
export const setHeaderRight = async (items: HeaderRightOperationItem[]) => {
  if (!items.length) return;
  avatrNative.canIUse(["setHeaderRightOperation"]).then((ret) => {
    if (ret?.result) {
      avatrNative.callNative("setHeaderRightOperation", {
        items,
      });
    } else {
      console.log(`当前app版本不支持setHeaderRightOperation方法.`);
    }
  });
};

export enum AppVersion {
  CURRENT = "current",
  OLD = "old",
  NEXT = "next",
}

/**
 * 版本比较
 */
export const compareVersion = (
  version1: string,
  version2: string = "2.0.4"
): AppVersion => {
  const v1 = version1.split(".");
  const v2 = version2.split(".");
  // avatr app 版本号一直保持的是x.x.x格式 不在判断版本号长度
  const len = v2.length;
  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i]);
    const num2 = parseInt(v2[i]);
    if (num1 > num2) {
      // 比v2版本新
      return AppVersion.NEXT;
    } else if (num1 < num2) {
      // 比v2版本老
      return AppVersion.OLD;
    }
  }
  // v1与v2 版本一致
  return AppVersion.CURRENT;
};

/**
 * 正则返回匹配的字符串
 * return string[]
 */
function getExecStr(str, reg) {
  var list = [];
  var result = null;
  do {
    result = reg.exec(str);
    result && list.push(result[1]);
  } while (result);
  return list;
}

// 获取App信息
export function getAppInfo() {
  const res: any = avatrNative.appInfo;
  // {avatrVersion, token, isLogin}
  return res || {};
}

enum BackupType {
  LINK = 0,
  TOAST = 1,
}

// 配置跳转
export function jumpConfigFn(configInfo, configData = {}) {
  try {
    const { url = "" } =
      (BROWSER_TYPE.App
        ? configInfo.appUrlInfo
        : BROWSER_TYPE.Weapp
        ? configInfo.weappUrlInfo
        : configInfo?.h5UrlInfo) || {};
    if (!url) {
      showToast({ type: "error", message: `当前配置不支持跳转` });
      return;
    }
    var reg = /\$\{(.+?)\}/g;
    // 处理url中的动态参数，例如userId
    const needReplace = getExecStr(url, reg);
    //
    let targetUrl = url;
    needReplace.forEach((item) => {
      const oldKey = "${" + item + "}";
      targetUrl = targetUrl.replace(oldKey, configData[item]);
    });

    if (BROWSER_TYPE.App) {
      const { appUrlInfo } = configInfo;
      const { lowestVersion, backupType, backupString } = appUrlInfo;
      // 存在低版本判断，
      if (lowestVersion) {
        const { avatrVersion } = getAppInfo();
        const version = compareVersion(avatrVersion, lowestVersion);
        // 旧版本跳转H5
        if (version === AppVersion.OLD && BackupType.LINK === backupType) {
          ResourceNavigation({ jumpType: 0, jumpRoute: backupString });
          return;
        } else if (
          version === AppVersion.OLD &&
          BackupType.TOAST === backupType
        ) {
          // toast提示
          showToast({ type: "error", message: backupString });
          return;
        }
      }
      console.log("appUrl==", targetUrl);
      openApp(targetUrl);
    } else if (BROWSER_TYPE.Weapp) {
      console.log("微信小程序Url==", targetUrl);
      const wxType = getWxJumpKey(targetUrl);
      wx.miniProgram[wxType]({ url: targetUrl });
    } else {
      console.log("H5Url==", targetUrl);
      window.location.href = targetUrl;
    }
  } catch (err) {
    showToast({ type: "error", message: `当前配置不支持跳转[错误]` });
    console.error(err);
  }
}

/**
 * 获取token, 且H5页面在生产环境中仅有两种存在形式: 1.内嵌app; 2.内嵌微信小程序
 * app中永远从UA中取, app已经收口
 * 小程序中从url上取
 */
export const getToken = () => {
  let token = "";
  if (clientHelper.ClientInfo.isAvatrApp) {
    const info = avatrNative.appInfo;
    token = info?.isLogin === "true" ? info?.token : "";
  } else if (clientHelper.ClientInfo.isWeApp || clientHelper.ClientInfo.isTTMiniApp) {
    token = new URL(window.location.href).searchParams.get("token");
  } else {
    // 浏览器 && 开发环境
    // if (process.env.NODE_ENV === "development") { // 临时放开用
    // }
    if (window?.localStorage) {
      token = window.localStorage.getItem(AUTH_TOKEN) || "";
    }
  }
  return token;
};

/**
 * app版本从3.0.16之后支持私信好友的分享，判断版本号返回对应分享面板参数
 * shareArr
 *
 */
export const getParamsByAppVersion = () => {
  const info = avatrNative.appInfo;
  const appVersion: AppVersion= compareVersion(info?.avatrVersion, "3.0.16")
  const isOldVersion = appVersion === AppVersion.OLD;
  return isOldVersion ? [1, 2] : [1, 2, 3];
};

export const isAvatrApp = () => {
  return clientHelper.ClientInfo.isAvatrApp;
}
